import { Add, EmojiEvents, Link, Remove } from "@mui/icons-material";
import { Avatar, Divider, Grid, IconButton, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "moment/locale/ca";
import PageAdmin from "../../components/PageAdmin";
import Loading from "../../components/Loading";
import { Finals, Inscrits } from "../../db/firebase";
import { useCountdown } from "../../components/countdown";
import { ThemeProvider } from "@mui/styles";
import InscritsColumns from "../../components/tables/InscritsColumns";
import getMuiTheme from "../../components/tables/getMuiTheme";
import MUIDataTable from "mui-datatables";
import TableOptions from "../../components/tables/TableOptions";
import { ResultatsColumns } from "../../components/tables/ResultatsColumns";

export default function ResultatsAdmin() {
	const [loadingF, errorF, finals, getFinals, addFinals, removeFinals, removeInscrits] = Finals();
	const classes = useStyles();
	const [days, hours, minutes, seconds] = useCountdown(moment().format("YYYY-MM-DD HH:mm:ss"));
	const columns = ResultatsColumns();
	const options = TableOptions("inscrits");
	const [inscrits, setInscrits] = useState([]);

	useEffect(() => {
		getFinals();
	}, []);

	useEffect(() => {
		const x =
			finals?.length > 0 &&
			finals
				?.map((val) => val?.llista ?? [])
				.reduce((pre, cur) => pre.concat(cur))
				.map((e) => e);
		finals?.length > 0 && setInscrits(x);
	}, [finals]);

	return (
		<PageAdmin title="Resultats sorteig">
			<Loading loading={loadingF}>
				<Box className={classes.bloc} mb={3}>
					<ThemeProvider theme={getMuiTheme()}>
						<MUIDataTable data={inscrits} columns={columns} options={options} />
					</ThemeProvider>
				</Box>
			</Loading>
		</PageAdmin>
	);
}

const useStyles = makeStyles((theme) => ({
	bloc: {
		padding: 40,
	},
}));
